import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import SectionError from "./section-error";
import { delay, onlyNumbers, removeEmptyKeys } from "../../utils/utils";
import { showToast } from "../../utils/constants";
import { chain, isEqual, zipObject } from "lodash";
import MaterialInput from "../inputs/material-input.vue";
import { withValidSin } from "@Shared/@Utils/validation-rules";
import { validationMixin } from "vuelidate";
import { isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SinSection",
  components: {
    SectionError,
    MaterialInput
  },
  mixins: [validationMixin],
  model: {
    prop: "value",
    event: "change"
  },
  validations: {
    formattedValue: {
      withValidSin
    }
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    value: {
      type: Object,
      default() {
        return {
          1: "",
          2: "",
          3: ""
        };
      }
    },
    show: {
      type: Function,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    labelFor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      formattedValue: removeEmptyKeys(this.value),
      isSinComplete: false,
      labelValue: isEmpty(this.labelFor) ? uuidv4() : this.labelFor
    };
  },
  computed: {
    validSin() {
      return !this.$v.$invalid;
    },
    inputVal: {
      get() {
        var _context;
        return _valuesInstanceProperty(_context = chain(this.formattedValue)).call(_context).join(" ").value();
      },
      set(val) {
        var _context2;
        this.formattedValue = zipObject([1, 2, 3], _mapInstanceProperty(_context2 = val.split(" ")).call(_context2, formatted => (formatted == null ? void 0 : _trimInstanceProperty(formatted).call(formatted)) || ""));
        this.calculateIsSinComplete(this.formattedValue);
      }
    },
    obfuscatedSIN() {
      return /^\d{3} X{3} X{3}$/.test(this.inputVal);
    },
    tooltipTitle() {
      return this.obfuscatedSIN ? this.$t("application.actions.showFullSin") : this.$t("application.actions.hideFullSin");
    },
    shouldShowToggle() {
      return this.obfuscatedSIN || this.validSin && this.isSinComplete;
    },
    showSinIconName() {
      return this.obfuscatedSIN ? "eye" : "eye-slash";
    }
  },
  watch: {
    value(val) {
      this.formattedValue = removeEmptyKeys(val);
    },
    formattedValue: {
      async handler(formattedValue, oldFormattedValue) {
        if (isEqual(formattedValue, oldFormattedValue)) return;
        await this.calculateIsSinComplete(formattedValue);
        if (!this.isSinComplete) {
          return;
        }
        if (!this.obfuscatedSIN) {
          this.notifyChange();
        }
      },
      immediate: true
    }
  },
  methods: {
    async handleChange(value) {
      this.inputVal = value;

      //give enough time to trigger watch calculations
      await delay(200);
      if (this.validSin) {
        this.hideFullSIN();
      }
    },
    notifyChange() {
      this.$emit("change", this.formattedValue);
    },
    onlyNumbers(event) {
      return onlyNumbers(event);
    },
    toggleFullSIN() {
      if (this.obfuscatedSIN) this.showFullSIN();else this.hideFullSIN();
    },
    hideFullSIN() {
      this.inputVal = `${this.formattedValue[1]} XXX XXX`;
    },
    async showFullSIN() {
      if (this.loading) return;
      try {
        await this.show();
      } catch (e) {
        showToast("error", "sinFailed");
        Amplitude.logHandledError(e, {}, "sinFailed");
      }
    },
    async calculateIsSinComplete(formattedValue) {
      await this.$nextTick();
      const values = _Object$values(formattedValue);
      const isSinEmpty = _includesInstanceProperty(values).call(values, "");
      const isMaskComplete = this.$refs.targetInput.inputmask.isComplete();
      this.isSinComplete = this.obfuscatedSIN || isMaskComplete || isSinEmpty;
    }
  }
});